import React, { useState } from "react";
import Header from "./header";
import Slide from "@material-ui/core/Slide";
import { connect } from "react-redux";
import { get_balance, get_currencyCode, get_dateFormat, get_lang, get_LeftRight, get_withdrawableBalance } from "../../../helper/UserData/userdate";
import Loading from "./loading";
import Error from "./error";
import { getLogoTypeByUrl } from "../../../helper/module";
import { withTranslation, Trans } from "react-i18next";
import Maincss from "./main.module.css";
import IconProviderSvgModifier from "../../../design-system/lib/IconProviderSvgModifier";
import { ReactComponent as withdraw_cash_out } from "../../../static/IconProvider/withdraw/ic_cash_out.svg";
import Typography from "../../../design-system/lib/Typography";
import { CLOSE_DARK, INFO_CIRCLE, withdraw_done, withdraw_notes, withdraw_price, withdraw_reject, withdraw_wait } from "../../../static";
import Button from "../../../design-system/lib/Button";
import Backdrop from "@material-ui/core/Backdrop";
import { withStyles } from "@material-ui/core/styles";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Paper from "@material-ui/core/Paper";
import close from "../../../static/ic-close.svg";
import { ReactComponent as withdraw_wallet } from "../../../static/IconProvider/withdraw/wallet.svg";
import Input from "../../../design-system/lib/Input";
import { Customer_Get_withdrawList, Customer_Post_withdrawList } from "../../../helper/api";
import { isEmpty, isNumber } from "lodash";
import momentJalaali from "moment-jalaali";
import { snack } from "../../../helper/module/SnackbarUtilsConfigurator";

const BackdropCustom = withStyles({
  backdrop: {
    zIndex: 5000,
    backgroundColor: "rgba(0, 0, 0, 0)",
    color: "#00000",
  },
})((props) => (
  <Backdrop
    {...props}
    style={{
      zIndex: 5000,
      width: "100vw",
      height: "100vh",
      backgroundColor: "#00000066",
      color: "#00000",
    }}
  />
));


class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      withdrawList: [],
      loading: true,
      selectedItem: null,
      newWithdrawDialoge: false,
      newWithdrawAmount: undefined,
      newWithdrawNote: ""
    };

    this.addWithdraw = this.addWithdraw.bind(this)

  }



  componentDidMount() {
    this.setState({
      loading: true
    })
    Customer_Get_withdrawList(this.props.dispatch, {}, (res) => {
      console.log("Customer_Get_withdrawList ", res)
      this.setState({
        withdrawList: res,
        loading: false
      })
    })
  }

  getIconByStatus(status) {
    switch (status) {
      case "Pending":
        return withdraw_wait
      case "Rejected":
        return withdraw_reject
      case "Completed":
        return withdraw_done
      default:
        return withdraw_wait
    }
  }
  getColorByStatus(status) {
    switch (status) {
      case "Pending":
        return "#1080FF"
      case "Rejected":
        return "#D01400"
      case "Completed":
        return "#009B62"
      default:
        return "#1080FF"
    }
  }

  getrequestedTextByStatus(status) {
    switch (status) {
      case "Pending":
        return this.props.t("requested")
      case "Rejected":
        return this.props.t("requested")
      case "Completed":
        return this.props.t("withdrawed")
      default:
        return this.props.t("requested")
    }
  }


  addWithdraw() {

    this.setState({
      newWithdrawDialoge: false
    })

    Customer_Post_withdrawList(this.props.dispatch, {
      requestedAmount: this.state.newWithdrawAmount,
      note: this.state.newWithdrawNote
    }, (status) => {
 
      this.setState({
        newWithdrawAmount: undefined,
        newWithdrawNote: ""
      })
      if (status) {

        snack.SuccTitleDescSnackbar(JSON.stringify({
          "title": this.props.t("Request Sent"),
          "description": this.props.t("Your request will be check in the next 24 hours.")
        }))


        this.componentDidMount()
      } 
    })
  }
  render() {

    let canAddWithdraw = (Number(get_withdrawableBalance()) >= Number(this.state.newWithdrawAmount)) || !this.state.newWithdrawAmount ||  isEmpty(String(this.state.newWithdrawAmount).trim())  

    return (
      <>

        <Slide
          timeout={650}
          direction={get_LeftRight()}
          in={this.props.open}
          mountOnEnter
          unmountOnExit
        >
          <div className="OrderHistoryContainer">
            <Header onnewWithdrawDialoge={() => {
              this.setState({
                newWithdrawDialoge: true,
                newWithdrawAmount: undefined,
                newWithdrawNote: ""
              })
            }} />
            {/* <Error /> */}
            {this.state.loading && <Loading />}




            {!this.state.loading && <div className="aboutusinner" style={{ paddingTop: "7px" }}>

              {this.state.withdrawList.map((item) => {
                return <div className={Maincss.itemContainer} style={{cursor:"unset"}}>
                  <div className={Maincss.leftitemContainer}>
                    <div className={Maincss.leftTopitemContainer}>
                      <Typography weight="Body_Middle_Medium" text={momentJalaali(item.createdAt).locale(get_lang()).format(get_dateFormat())} style={{ color: "#242424" }} />
                      <Typography weight="Body_Tiny_Regular" text={Number(item.requestedAmount).toLocaleString(get_lang(), {
                        style: "currency",
                        currency: item.currencyCode,
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                      }) + " " + this.getrequestedTextByStatus(item.status)} style={{ color: "#979797" }} />
                    </div>
                    <div className={Maincss.leftBottomitemContainer}>
                      <img src={this.getIconByStatus(item.status)} />
                      <Typography weight="Body_Small_Regular" text={item.statusDescription} style={{ color: this.getColorByStatus(item.status) }} />
                    </div>
                  </div>
                  <Button onClick={() => {
                    this.setState({
                      selectedItem: item
                    })
                  }} size="Medium" type="Secondary" icon={INFO_CIRCLE} style={{ marginInlineStart: "auto", marginInlineEnd: "16px" }} />
                </div>
              })}

              {/* <div className={Maincss.itemContainer}>
                <div className={Maincss.leftitemContainer}>
                  <div className={Maincss.leftTopitemContainer}>
                    <Typography weight="Body_Middle_Medium" text={"4 July 22:24"} style={{ color: "#242424" }} />
                    <Typography weight="Body_Tiny_Regular" text={"$20 requested"} style={{ color: "#979797" }} />
                  </div>
                  <div className={Maincss.leftBottomitemContainer}>
                    <img src={withdraw_wait} />
                    <Typography weight="Body_Small_Regular" text={"Under review"} style={{ color: "#1080FF" }} />
                  </div>
                </div>
                <Button size="Medium" type="Secondary" icon={INFO_CIRCLE} style={{ marginInlineStart: "auto", marginInlineEnd: "16px" }} />
              </div>

              <div className={Maincss.itemContainer}>
                <div className={Maincss.leftitemContainer}>
                  <div className={Maincss.leftTopitemContainer}>
                    <Typography weight="Body_Middle_Medium" text={"4 July 22:24"} style={{ color: "#242424" }} />
                    <Typography weight="Body_Tiny_Regular" text={"$20 requested"} style={{ color: "#979797" }} />
                  </div>
                  <div className={Maincss.leftBottomitemContainer}>
                    <img src={withdraw_done} />
                    <Typography weight="Body_Small_Regular" text={"Done"} style={{ color: "#009B62" }} />
                  </div>
                </div>
                <Button size="Medium" type="Secondary" icon={INFO_CIRCLE} style={{ marginInlineStart: "auto", marginInlineEnd: "16px" }} />
              </div>


              <div className={Maincss.itemContainer}>
                <div className={Maincss.leftitemContainer}>
                  <div className={Maincss.leftTopitemContainer}>
                    <Typography weight="Body_Middle_Medium" text={"4 July 22:24"} style={{ color: "#242424" }} />
                    <Typography weight="Body_Tiny_Regular" text={"$20 requested"} style={{ color: "#979797" }} />
                  </div>
                  <div className={Maincss.leftBottomitemContainer}>
                    <img src={withdraw_reject} />
                    <Typography weight="Body_Small_Regular" text={"Denied"} style={{ color: "#D01400" }} />
                  </div>
                </div>
                <Button size="Medium" type="Secondary" icon={INFO_CIRCLE} style={{ marginInlineStart: "auto", marginInlineEnd: "16px" }} />
              </div> */}

              {isEmpty(this.state.withdrawList) && <div className={Maincss.nowithdrawContainer}>

                <IconProviderSvgModifier Icon={withdraw_cash_out} size="32" className="img" />
                <Typography weight="Body_Middle_Bold" text={this.props.t("No withdraw yet")} style={{ color: "#242424", marginTop: "16px" }} />
                <Typography weight="Body_Tiny_Regular" text={this.props.t("Your withdraws outs will appear here")} style={{ color: "#808080", marginTop: "4px" }} />

              </div>}


            </div>}

          </div>


        </Slide>


        {this.state.newWithdrawDialoge && <BackdropCustom open={true}>
          <Paper
            style={{ width: "100%", maxWidth: "520px", height: "auto", borderRadius: "8px", paddingBottom: "10px" }}
          >
            <ClickAwayListener onClickAway={()=>{
              this.setState({
                newWithdrawDialoge: false,
                newWithdrawAmount: undefined,
                newWithdrawNote: ""
              })
            }}>
              <div style={{ width: "100%", height: "100%" }}>
                <div className="podheader" style={{ display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", height: "52px" }}>
                  <Button size="Medium" onClick={()=>{
                       this.setState({
                        newWithdrawDialoge: false,
                        newWithdrawAmount: undefined,
                        newWithdrawNote: ""
                      })
                  }} type="Secondary" icon={close} style={{ marginInlineStart: "16px", marginInlineEnd: "12px" }} />
                  {/* <img
                           src={IconClose}
                           className="close"
                           onClick={this.handleOpen}
                         /> */}
                  <Typography weight="Body_Middle_Bold" text={this.props.t("Request Withdraw")} style={{ color: "#242424" }} />

                </div>

                <div className={Maincss.RequestWithdrawContainerOuter}>
                  <div className={Maincss.RequestWithdrawContainer}>
                    <div className={Maincss.itemx1Container}>
                      <IconProviderSvgModifier Icon={withdraw_wallet} size="16" className="img" />
                      <div className={Maincss.itemx1TTContainer}>
                        <Typography weight="Body_Middle_Medium" text={Number(get_balance()).toLocaleString(get_lang(), {
                          style: "currency",
                          currency: get_currencyCode(),
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 5,
                        })} style={{ color: "#242424" }} />
                        <Typography weight="Subtitle_Tiny_Regular" text={this.props.t("Balance")} style={{ color: "#808080" }} />

                      </div>

                    </div>
                    <div style={{ width: "100%", height: "1px", backgroundColor: "#F4F4F7" }} />

                    <div className={Maincss.itemx1Container}>
                      <IconProviderSvgModifier Icon={withdraw_cash_out} size="16" className="img" />
                      <div className={Maincss.itemx1TTContainer}>
                        <Typography weight="Body_Middle_Medium" text={Number(get_withdrawableBalance()).toLocaleString(get_lang(), {
                          style: "currency",
                          currency: get_currencyCode(),
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 5,
                        })} style={{ color: "#242424" }} />
                        <Typography weight="Subtitle_Tiny_Regular" text={this.props.t("Withdrawable")} style={{ color: "#808080" }} />

                      </div>

                    </div>
                  </div>
                </div>
                <div className={Maincss.RequestWithdrawContainerOuter}>
                  <div className={Maincss.RequestWithdrawContainer}>

                    <Input value={this.state.newWithdrawAmount || ""} 
                    error={(!isEmpty(this.state.newWithdrawAmount) && (Number(get_withdrawableBalance()) < Number(this.state.newWithdrawAmount))) && this.props.t("It can’t be more than your balance")} type={"number"} title={this.props.t("Requested amount")} placeHolder={this.props.t("Ex. 100")} onChange={(e) => {
                      this.setState({
                        newWithdrawAmount: isEmpty(e.target.value) ? undefined : e.target.value 
                      })
                    }} />
                     <Input type={"text"} title="Your note" placeHolder={this.props.t("Ex. Additional note")} onChange={(e) => {
                      this.setState({
                        newWithdrawNote: e.target.value
                      })
                    }} />


                  </div>
                </div>

                <div className={Maincss.RequestWithdrawFooterContainer}>
                  <Typography weight="Body_Middle_Bold" style={{ opacity: canAddWithdraw ? "1" : ".5", cursor: canAddWithdraw ? "pointer" : "not-allowed" }} text={this.props.t("Withdraw")} className={Maincss.Requestwidthdraw} onClick={canAddWithdraw && this.addWithdraw} />

                </div>

              </div>
            </ClickAwayListener>
          </Paper>
        </BackdropCustom>}

        {this.state.selectedItem && <BackdropCustom open={true}>
          <Paper
            style={{ width: "100%", maxWidth: "520px", height: "auto", borderRadius: "8px", paddingBottom: "10px" }}
          >
            <ClickAwayListener onClickAway={() => {
              this.setState({
                selectedItem: null
              })
            }}>
              <div style={{ width: "100%", height: "100%" }}>
                <div className="podheader" style={{ display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", height: "52px" }}>
                  <Button onClick={() => {
                    this.setState({
                      selectedItem: null
                    })
                  }} size="Medium" type="Secondary" icon={close} style={{ marginInlineStart: "16px", marginInlineEnd: "12px" }} />
                  {/* <img
                           src={IconClose}
                           className="close"
                           onClick={this.handleOpen}
                         /> */}
                  <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "start", gap: "2px" }}>
                    <Typography weight="Body_Middle_Bold" text={this.props.t("Withdraw info")} style={{ color: "#242424" }} />
                    <Typography weight="Body_Small_Regular" text={momentJalaali(this.state.selectedItem.createdAt).locale(get_lang()).format(get_dateFormat())} style={{ color: "#808080" }} />
                  </div>

                </div>

                <div className={Maincss.RequestWithdrawContainerOuter} style={{ borderBottom: "unset" }}>
                  <div className={Maincss.RequestWithdrawContainer} style={{ margin: "0px 16px -10px 16px" }}>
                    <div className={Maincss.itemx1Container}>
                      <img src={this.getIconByStatus(this.state.selectedItem.status)} style={{ marginTop: "1px" }} />
                      <div className={Maincss.itemx1TTContainer}>
                        <Typography weight="Body_Middle_Medium" text={this.state.selectedItem.status} style={{ color: "#242424" }} />
                        <Typography weight="Subtitle_Tiny_Regular" text={this.props.t("Status")} style={{ color: "#808080" }} />

                      </div>

                    </div>
                    <div style={{ width: "100%", height: "1px", backgroundColor: "#F4F4F7" }} />

                    <div className={Maincss.itemx1Container}>
                      <IconProviderSvgModifier Icon={withdraw_cash_out} size="16" className="img" />
                      <div className={Maincss.itemx1TTContainer}>
                        <Typography weight="Body_Middle_Medium" text={Number(this.state.selectedItem.amount).toLocaleString(get_lang(), {
                          style: "currency",
                          currency: this.state.selectedItem.currencyCode,
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 2,
                        })} style={{ color: "#242424" }} />
                        <Typography weight="Subtitle_Tiny_Regular" text={this.props.t("Withdraw amount")} style={{ color: "#808080" }} />

                      </div>

                    </div>

                    {!isEmpty(this.state.selectedItem.description) && <> <div style={{ width: "100%", height: "1px", backgroundColor: "#F4F4F7" }} />

                      <div className={Maincss.itemx1Container}>
                        <img src={withdraw_notes} style={{ width: "16px" }} />
                        <div className={Maincss.itemx1TTContainer}>
                          <Typography weight="Body_Middle_Medium" text={this.state.selectedItem.description} style={{ color: "#242424" }} />
                          <Typography weight="Subtitle_Tiny_Regular" text={this.props.t("Description")} style={{ color: "#808080" }} />

                        </div>

                      </div>
                    </>}


                    <div style={{ width: "100%", height: "1px", backgroundColor: "#F4F4F7" }} />

                    <div className={Maincss.itemx1Container}>
                      <img src={withdraw_price} style={{ width: "16px" }} />
                      <div className={Maincss.itemx1TTContainer}>
                        <Typography weight="Body_Middle_Medium" text={Number(this.state.selectedItem.requestedAmount).toLocaleString(get_lang(), {
                          style: "currency",
                          currency: this.state.selectedItem.currencyCode,
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 2,
                        })} style={{ color: "#242424" }} />
                        <Typography weight="Subtitle_Tiny_Regular" text={this.props.t("Requested amount ")} style={{ color: "#808080" }} />

                      </div>

                    </div>


                    {!isEmpty(this.state.selectedItem.note) && <>
                      <div style={{ width: "100%", height: "1px", backgroundColor: "#F4F4F7" }} />

                      <div className={Maincss.itemx1Container}>
                        <img src={withdraw_notes} style={{ width: "16px" }} />
                        <div className={Maincss.itemx1TTContainer}>
                          <Typography weight="Body_Middle_Medium" text={this.state.selectedItem.note} style={{ color: "#242424" }} />
                          <Typography weight="Subtitle_Tiny_Regular" text={this.props.t("Your notes")} style={{ color: "#808080" }} />

                        </div>

                      </div></>}
                  </div>
                </div>



              </div>
            </ClickAwayListener>
          </Paper>
        </BackdropCustom>
        }

      </>



    );
  }
}

const mapStateToProps = (state) => ({
  open: state.Withdraw.openDialoge,
  error: state.Withdraw.error,
  loading: state.Withdraw.loading,
  data: state.Withdraw.data,
});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));
